import React from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import AppShell from "../../components/AppShell";
import { fetchMonitorDevices, monitorLogout } from "../../api/client";
import "../shared/MonitorFlowPage.css";

export default function DeviceListPage() {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const groupCode = searchParams.get("group") || "";
  const [devices, setDevices] = React.useState([]);
  const [error, setError] = React.useState("");

  React.useEffect(() => {
    let mounted = true;

    fetchMonitorDevices()
      .then((data) => {
        if (!mounted) return;
        setDevices(data.devices || []);
      })
      .catch((loadError) => {
        if (!mounted) return;
        setError(loadError.message || "디바이스 목록을 불러오지 못했습니다.");
        navigate("/login", { replace: true });
      });

    return () => {
      mounted = false;
    };
  }, [navigate]);

  const handleLogout = async () => {
    await monitorLogout();
    navigate("/login", { replace: true });
  };

  const groups = Array.from(
    new Set(devices.map((device) => device?.group?.group_code).filter(Boolean))
  );
  const filteredDevices = groupCode
    ? devices.filter((device) => device?.group?.group_code === groupCode)
    : devices;

  const handleGroupFilter = (code) => {
    if (!code) {
      setSearchParams({});
      return;
    }
    setSearchParams({ group: code });
  };

  return (
    <AppShell
      title="디바이스 목록"
      subtitle="전체 디바이스를 한 번에 보고, 필요하면 그룹으로 좁혀서 바로 상세 화면으로 이동합니다."
      actions={<button className="action-btn" onClick={handleLogout} title="로그아웃">
        <svg viewBox="-8 -5 40 30" preserveAspectRatio="none" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M2 6.5C2 4.01472 4.01472 2 6.5 2H12C14.2091 2 16 3.79086 16 6V7C16 7.55228 15.5523 8 15 8C14.4477 8 14 7.55228 14 7V6C14 4.89543 13.1046 4 12 4H6.5C5.11929 4 4 5.11929 4 6.5V17.5C4 18.8807 5.11929 20 6.5 20H12C13.1046 20 14 19.1046 14 18V17C14 16.4477 14.4477 16 15 16C15.5523 16 16 16.4477 16 17V18C16 20.2091 14.2091 22 12 22H6.5C4.01472 22 2 19.9853 2 17.5V6.5ZM18.2929 8.29289C18.6834 7.90237 19.3166 7.90237 19.7071 8.29289L22.7071 11.2929C23.0976 11.6834 23.0976 12.3166 22.7071 12.7071L19.7071 15.7071C19.3166 16.0976 18.6834 16.0976 18.2929 15.7071C17.9024 15.3166 17.9024 14.6834 18.2929 14.2929L19.5858 13L11 13C10.4477 13 10 12.5523 10 12C10 11.4477 10.4477 11 11 11L19.5858 11L18.2929 9.70711C17.9024 9.31658 17.9024 8.68342 18.2929 8.29289Z" fill="#0F1729"/>
        </svg>
      </button>}
    >
      <div className="flow-grid device-list-grid">
        {error ? <div className="error-box">{error}</div> : null}
        <section className="card">
          <div className="card__header">
            <h2>그룹 필터</h2>
          </div>
          <div className="card__body">
            <div className="tabs group-filter-tabs">
              <button type="button" className={!groupCode ? "active" : ""} onClick={() => handleGroupFilter("")}>
                <span>전체</span>
              </button>
              {groups.map((code) => (
                <button
                  key={code}
                  type="button"
                  className={groupCode === code ? "active" : ""}
                  onClick={() => handleGroupFilter(code)}
                >
                  <span>{code}</span>
                </button>
              ))}
            </div>
          </div>
        </section>

        <section className="card">
          <div className="card__header no-space">
            <h2>전체 디바이스</h2>
            <span className="card__cnt">{filteredDevices.length}개</span>
          </div>
          <div className="card__body">
            {!filteredDevices.length ? (
              <div className="empty-state">표시할 디바이스가 없습니다.</div>
            ) : (
              <div className="device-list gr-dv-list">
                {filteredDevices.map((device) => (
                  <article key={device.device_key} className="device-card">
                    <Link to={`/monitor/devices/${device.device_key}`}>
                      <strong>{device.name}</strong>
                      <div className="meta-row">
                        <span>{device.device_key}</span>
                        <span>{device.group?.name || device.group?.group_code || "-"}</span>
                      </div>
                      <div className="badge-row">
                        <span className="badge status">{device.status || "미지정"}</span>
                        <span className="badge">{device.frontend_skin || "monitor_card"}</span>
                      </div>
                    </Link>
                  </article>
                ))}
              </div>
            )}
          </div>
        </section>
      </div>
    </AppShell>
  );
}
